import React from 'react';
import SEO from '../components/SEO';

const APropos = () => {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 py-12">
      <SEO 
        title="À Propos | Village Artisanal Sénégal - FIDAK Soumbédioune | Notre Mission"
        description="Village Artisanal Sénégal - Partenaire officiel FIDAK et soutenu par le Ministère de l'Artisanat du Sénégal. Nous promouvons l'artisanat sénégalais authentique : poterie, vannerie, bijoux, maroquinerie, textiles traditionnels. Commerce équitable et développement des artisans locaux."
        keywords="village artisanal mission, FIDAK partenaire, ministère artisanat sénégal, soumbédioune histoire, artisanat traditionnel sénégal, commerce équitable dakar, artisans certifiés sénégal, made in senegal authentique"
        type="website"
      />
      <div className="max-w-4xl mx-auto px-4">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-display font-bold text-gray-900 dark:text-primary-300 mb-4">
            À Propos de Village Artisanal
          </h1>
          <p className="text-xl text-gray-600 dark:text-gray-400">
          </p>
        </div>

        <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md p-8 mb-8">
          <h2 className="text-2xl font-display font-bold text-gray-900 dark:text-primary-300 mb-6">Notre Mission</h2>
          <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-6">
            Le <strong>Village Artisanal Sénégal</strong> est le premier marché d'artisanat 
            sénégalais authentique. Notre plateforme digitale 
            permet aux artisans sénégalais certifiés de mettre en valeur leur savoir-faire unique en 
            poterie, vannerie, bijoux traditionnels, maroquinerie en cuir, textiles bogolan et batik 
            <strong> made in Senegal</strong>.
          </p>
          <p className="text-gray-700 dark:text-primary-300 leading-relaxed">
            Nous croyons en un <strong>commerce équitable</strong> qui valorise les artisans locaux. Chaque 
            pièce artisanale raconte une histoire, porte en elle des siècles de tradition africaine et 
            mérite d'être préservée. C'est pourquoi nous nous engageons à offrir une vitrine digitale 
            moderne qui connecte l'artisanat traditionnel sénégalais avec le monde entier, tout en 
            respectant les valeurs culturelles du Sénégal.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8">
          <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md p-8">
            <div className="text-center mb-6">
              <div className="w-16 h-16 bg-primary-100 dark:bg-primary-900/40 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="fas fa-users text-2xl text-primary-800 dark:text-primary-400"></i>
              </div>
              <h3 className="text-xl font-display font-bold text-gray-900 dark:text-primary-300">Communauté</h3>
            </div>
            <p className="text-gray-700 dark:text-gray-300 text-center">
              Nous rassemblons artisans et amateurs d'art dans une communauté unie par 
              la passion du beau et de l'authentique.
            </p>
          </div>

          <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md p-8">
            <div className="text-center mb-6">
              <div className="w-16 h-16 bg-primary-100 dark:bg-primary-900/40 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="fas fa-heart text-2xl text-primary-800 dark:text-primary-400"></i>
              </div>
              <h3 className="text-xl font-display font-bold text-gray-900 dark:text-primary-300">Authenticité</h3>
            </div>
            <p className="text-gray-700 dark:text-gray-300 text-center">
              Chaque produit sur notre plateforme est soigneusement sélectionné pour 
              garantir son authenticité et sa qualité exceptionnelle.
            </p>
          </div>

          <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md p-8">
            <div className="text-center mb-6">
              <div className="w-16 h-16 bg-primary-100 dark:bg-primary-900/40 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="fas fa-globe text-2xl text-primary-800 dark:text-primary-400"></i>
              </div>
              <h3 className="text-xl font-display font-bold text-gray-900 dark:text-primary-300">Accessibilité</h3>
            </div>
            <p className="text-gray-700 dark:text-gray-300 text-center">
              Nous rendons l'artisanat sénégalais accessible au monde entier grâce 
              à notre plateforme digitale moderne et intuitive.
            </p>
          </div>

          <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md p-8">
            <div className="text-center mb-6">
              <div className="w-16 h-16 bg-primary-100 dark:bg-primary-900/40 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="fas fa-seedling text-2xl text-primary-800 dark:text-primary-400"></i>
              </div>
              <h3 className="text-xl font-display font-bold text-gray-900 dark:text-primary-300">Durabilité</h3>
            </div>
            <p className="text-gray-700 dark:text-gray-300 text-center">
              Nous soutenons une économie durable en valorisant les techniques 
              artisanales traditionnelles et respectueuses de l'environnement.
            </p>
          </div>
        </div>

        <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md p-8">
          <h2 className="text-2xl font-display font-bold text-gray-900 dark:text-primary-300 mb-6">Notre Impact</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
            <div>
              <div className="text-3xl font-bold text-primary-800 dark:text-primary-400 mb-2">500+</div>
              <div className="text-gray-700 dark:text-gray-300">Artisans partenaires</div>
            </div>
            <div>
              <div className="text-3xl font-bold text-primary-800 dark:text-primary-400 mb-2">2000+</div>
              <div className="text-gray-700 dark:text-gray-300">Produits authentiques</div>
            </div>
            <div>
              <div className="text-3xl font-bold text-primary-800 dark:text-primary-400 mb-2">14</div>
              <div className="text-gray-700 dark:text-gray-300">Régions couvertes</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default APropos;
